import { contentHash } from "../../utils";
import { ShopifyBaseAdminAppConfig } from "./ShopifyBaseAdminAppConfig";
import { EnvironmentNameMSTType, type LegacyEnvironmentName } from "../../Environment";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyLegacyAdminAppConfig = ShopifyBaseAdminAppConfig("ShopifyManualAppConfig")
  .props({
    environment: EnvironmentNameMSTType,
  })
  .views((self) => ({
    get contentHash() {
      return contentHash([self.apiKey, self.apiSecretKey, self.environment, self.shopDomain, self.accessToken]);
    },
  }))
  .actions((self) => ({
    setEnvironment(value: LegacyEnvironmentName) {
      self.environment = value;
    },
  }));
